export default "__VITE_ASSET__kESdOWrF__"